import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import './globalno.css';
import 'dayjs/locale/sl';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { tema } from './tema';
import { App } from './App';
import { seja } from './seja/seja';
import { NapakaApi } from './api/napaka';

const poizvedbe = new QueryClient({
  defaultOptions: {
    queries: {
      // napak, ki jih je vrnil strežnik (napačni parametri, ni dostopa), ne ponavljamo; povezavo poskusimo znova
      retry: (n, napaka) => n < 2 && napaka instanceof NapakaApi && napaka.status === 0,
      refetchOnWindowFocus: false,
    },
  },
});

// ob menjavi uporabnika ali instance (odjava, prijava kot uporabnik in nazaj) podatki prejšnje seje ne smejo ostati
let prejsnjaSeja = '';
seja.naroci(() => {
  const s = seja.dobi();
  const kljuc = s.status === 'prijavljen' ? `${s.instanca.id}|${s.uporabnik.uporabniskoIme}|${s.prijavaKot}` : '';
  if (kljuc !== prejsnjaSeja && prejsnjaSeja) {
    poizvedbe.clear();
  }
  prejsnjaSeja = kljuc;
});

// javna ponudba vozil (tudi vgrajena na tujih straneh) seje ne potrebuje
if (!window.location.pathname.startsWith('/ponudba/')) {
  void seja.zacni();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MantineProvider theme={tema} defaultColorScheme="light">
      <DatesProvider settings={{ locale: 'sl', firstDayOfWeek: 1 }}>
        <Notifications position="top-right" />
        <QueryClientProvider client={poizvedbe}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </DatesProvider>
    </MantineProvider>
  </StrictMode>,
);
